import { Routes } from '@angular/router';
import { authGuard } from '@infrastructure/guard/auth.guard';
import { getGuardRoles } from '@infrastructure/guard/roles';
import { MAIN_ROUTES } from '@infrastructure/routes/main.route';

export default [
  {
    canActivate: [authGuard],
    data: {
      roles: getGuardRoles(),
    },
    loadChildren: (): Promise<any> =>
      import('@modules/dashboard-page/components/dashboard-main-page/routes'),
    path: MAIN_ROUTES.DASHBOARD,
  },
  {
    data: {
      hasLogout: true,
    },
    loadChildren: (): Promise<any> =>
      import('@modules/access-denied-page/routes'),
    path: MAIN_ROUTES.DENIED,
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: MAIN_ROUTES.DASHBOARD,
  },
  {
    path: '**',
    redirectTo: MAIN_ROUTES.DASHBOARD,
  },
] satisfies Routes;
